import { Box, Typography, Container, Divider, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import img54 from "../../assets/ocesha_images/ocesha_logo.png";
import { useState, useEffect } from "react";

import { object, string, TypeOf } from "zod";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { toast } from "react-toastify";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
});

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>;
const PrivacyPage = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/codegenie/smart_contracts");
  };
  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({
    email: "",
    status: "",
  });
  const [newsSubsctiptionMutation, newsSubscriptionState] =
    useSubscribeNewsMutation();

  const methods = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmitHandler: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };

  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log("news subscription=>", response);
        const status = response.status;

        console.log(status);
        if (status === "success") {
          toast.success(response.message);
          setSubscribeVal({
            email: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? "Something went wrong!");
        console.error("Error sending query:", error);
      });
  };
  return (
    <>
      <Container maxWidth="lg">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}>
              <img src={img54} alt="" style={{ height: "70px" }} />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="">
                <i className="bi bi-list text-white" />
              </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll gap-4">
                <li className="nav-item">
                  <a
                    className="nav-link nav_active"
                    style={{ color: "#4ba5eb", fontWeight: 800 }}
                    href="/"
                  >
                    Home
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link nav_simple"
                    href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw"
                  >
                    Affiliate
                  </a>
                </li>
              </ul>

              <div className="d-flex gap-4" role="search">
                <button
                  className="button_leniar px-3"
                  type="submit"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Try Now
                </button>
                <button
                  className="btn btn-outline-primary px-3"
                  onClick={() => {
                    navigate("/signin");
                  }}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </nav>
        <Box py={5}>
          <Typography
            variant="h2"
            color="text.secondary"
            fontWeight={600}
            textAlign="justify"
            mb={10}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              OceSha.ai Privacy Policy{" "}
            </div>
          </Typography>
          <Typography>
            Last Updated: May 19, 2026
            <br />
            <br />
            OceSha, Inc. (“OceSha,” “we,” “us,” or “our”)  respects your privacy
            and is committed to protecting your personl information, uploaded
            content, voice data, Digital Twin data, and account information.
            <br />
            <br />
            This Privacy Policy explains how we collect, use, process, store,
            disclose, retain, and protect information when you access or use:
            <Box component="ul">
              <Box component="li">
                <Link
                  to=""
                  onClick={(e) => {
                    window.location.href = `https://ocesha.ai/`;
                    e.preventDefault();
                  }}
                  style={{
                    color: "#0168B5",
                  }}
                >
                  https://ocesha.ai
                </Link>
              </Box>
              <Box component="li">
                <Link
                  to=""
                  onClick={(e) => {
                    window.location.href = `https://ocesha.com/`;
                    e.preventDefault();
                  }}
                  style={{
                    color: "#0168B5",
                  }}
                >
                  https://ocesha.com
                </Link>
              </Box>
              <Box component="li">app.ocesha.ai</Box>
              <Box component="li">
                OceSha applications, dashboards, websites, public Authority
                Pages, AI Concierge tools, Digital Twin features, publishing
                tools, course tools, lead generation tools, and related services
                collectively, the “Services.”
              </Box>
            </Box>
            By accessing or using the Services, creating an account, uploading
            content, activating a Digital Twin, using voice features, publishing
            content, or interacting with OceSha’s AI systems, you agree to this
            Privacy Policy.
            <br />
            <br />
            If you do not agree with this Privacy Policy, do not use the
            Services.
          </Typography>

          {/* Section 1 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1. Information We Collect
          </Typography>
          <Typography>
            We collect information in several categories depending on how you
            use the Services.
          </Typography>

          {/* 1.1 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.1 Account Information
          </Typography>
          <Typography>
            When you create or manage an account, we may collect:
            <Box component="ul">
              <Box component="li">Name</Box>
              <Box component="li">Email address</Box>
              <Box component="li">Account credentials</Box>
              <Box component="li">Profile information</Box>
              <Box component="li">Profile image</Box>
              <Box component="li">Social media links</Box>
              <Box component="li">Subscription plan details</Box>
              <Box component="li">Billing status</Box>
              <Box component="li">Account preferences</Box>
              <Box component="li">Communication preferences</Box>
            </Box>
          </Typography>

          {/* 1.2 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.2 User Content and Uploads
          </Typography>
          <Typography>
            When you use the Services, you may upload, submit, connect, paste,
            record, or otherwise provide content, including:
            <Box component="ul">
              <Box component="li">Documents</Box>
              <Box component="li">PDFs</Box>
              <Box component="li">Word files</Box>
              <Box component="li">Presentations</Box>
              <Box component="li">Resumes and bios</Box>
              <Box component="li">Website URLs</Box>
              <Box component="li">Blog articles</Box>
              <Box component="li">Written notes</Box>
              <Box component="li">Scripts</Box>
              <Box component="li">Course materials</Box>
              <Box component="li">Audio recordings</Box>
              <Box component="li">Video files</Box>
              <Box component="li">Podcasts</Box>
              <Box component="li">Transcripts</Box>
              <Box component="li">Images</Box>
              <Box component="li">Social media content</Box>
              <Box component="li">Educational materials</Box>
              <Box component="li">Business and professional information</Box>
            </Box>
            We refer to this information as “User Content.” User Content may be
            processed by OceSha’s AI systems to provide the Services, including
            Digital Twin functionality, content recommendations, publishing
            tools, course creation, Authority Page generation, and AI-powered
            audience experiences.
            <br />
            <br />
            You retain ownership of your User Content, subject to the limited
            rights granted to OceSha to operate and provide the Services.
          </Typography>

          {/* 1.3 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.3 Digital Twin Data
          </Typography>
          <Typography>
            If you activate or use Digital Twin features, we may process
            information used to personalize your AI experience, including:
            <Box component="ul">
              <Box component="li">Uploaded content</Box>
              <Box component="li">Voice interactions</Box>
              <Box component="li">Voice samples</Box>
              <Box component="li">Speech patterns</Box>
              <Box component="li">Linguistic style</Box>
              <Box component="li">Communication style</Box>
              <Box component="li">Teaching or presentation style</Box>
              <Box component="li">Expertise and subject matter information</Box>
              <Box component="li">Interview responses</Box>
              <Box component="li">Profile information</Box>
              <Box component="li">Public-facing professional information</Box>
              <Box component="li">User preferences</Box>
            </Box>
            This information is used to generate, maintain, improve, and
            personalize your Digital Twin experience.
          </Typography>

          {/* 1.4 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.4 Voice Data and Synthetic Voice Processing
          </Typography>
          <Typography>
            If you use voice features, tap-to-speak interactions, voice
            personalization, or Digital Twin voice functionality, we may collect
            and process:
            <Box component="ul">
              <Box component="li">Voice recordings</Box>
              <Box component="li">Audio samples</Box>
              <Box component="li">Speech patterns</Box>
              <Box component="li">Tone, cadence, and pronunciation characteristics</Box>
              <Box component="li">Voice interaction transcripts</Box>
              <Box component="li">Synthetic voice configuration data</Box>
            </Box>
            Voice data may be used to help your Digital Twin communicate in a
            voice and speaking style that is more aligned with you across
            supported experiences.
            <br />
            <br />
            Voice data is used only for your account and your supported Digital
            Twin experience unless you provide separate explicit consent for
            another use.
            <br />
            <br />
            We do not sell your voice data.
            <br />
            <br />
            We do not use your voice data to create Digital Twins for other
            users.
            <br />
            <br />
            We do not use your private voice data to train public AI models
            unless expressly disclosed and separately consented to.
          </Typography>

          {/* 1.5 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.5 AI Concierge and Chat Interactions
          </Typography>
          <Typography>
            When you interact with the AI Concierge, Digital Twin, support chat,
            or AI-powered assistant features, we may collect:
            <Box component="ul">
              <Box component="li">Questions you ask</Box>
              <Box component="li">AI responses</Box>
              <Box component="li">Conversation history</Box>
              <Box component="li">Page context</Box>
              <Box component="li">Session context</Box>
              <Box component="li">Feedback or ratings</Box>
              <Box component="li">Support-related metadata</Box>
            </Box>
            These interactions may be used to provide responses, improve product
            performance, troubleshoot issues, personalize your experience, and
            maintain platform security.
          </Typography>

          {/* 1.6 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.6 Public Authority Page and Publishing Information
          </Typography>
          <Typography>
            If you create, generate, or publish an Authority Page, blogs,
            courses, social posts, clips, videos, or other public content, we
            may process:
            <Box component="ul">
              <Box component="li">Public profile information</Box>
              <Box component="li">Published content</Box>
              <Box component="li">Skill tags and expertise categories</Box>
              <Box component="li">Course information</Box>
              <Box component="li">Blog content</Box>
              <Box component="li">Video and podcast metadata</Box>
              <Box component="li">Public-facing Digital Twin interactions</Box>
              <Box component="li">Lead capture settings</Box>
              <Box component="li">Public URLs</Box>
              <Box component="li">Engagement activity</Box>
              <Box component="li">Visitor interactions</Box>
            </Box>
            Published content may become publicly accessible and may be indexed
            by search engines, AI search systems, web crawlers, or other
            third-party systems.
          </Typography>

          {/* 1.7 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.7 Lead Capture and Audience Engagement Data
          </Typography>
          <Typography>
            If you use lead generation, messaging, contact forms, Authority Page
            engagement, blog engagement, course enrollment, or audience
            interaction features, we may collect:
            <Box component="ul">
              <Box component="li">Visitor names</Box>
              <Box component="li">Visitor email addresses</Box>
              <Box component="li">Messages sent to you</Box>
              <Box component="li">Lead source information</Box>
              <Box component="li">Subscription or follow activity</Box>
              <Box component="li">Course enrollment activity</Box>
              <Box component="li">Engagement activity</Box>
              <Box component="li">Communication preferences</Box>
              <Box component="li">Related metadata</Box>
            </Box>
            You are responsible for using lead and audience data in compliance
            with applicable laws.
          </Typography>

          {/* 1.8 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.8 Payment and Billing Information
          </Typography>
          <Typography>
            For your OceSha subscription, payments are processed by third-party
            payment processors such as Stripe or other supported providers.
            <br />
            <br />
            We do not store full credit card numbers.
            <br />
            <br />
            We may collect or receive:
            <Box component="ul">
              <Box component="li">Subscription status</Box>
              <Box component="li">Plan type</Box>
              <Box component="li">Billing cycle</Box>
              <Box component="li">Payment history</Box>
              <Box component="li">Invoice records</Box>
              <Box component="li">Transaction amounts</Box>
              <Box component="li">Payment method status</Box>
              <Box component="li">Customer identifiers from payment processors</Box>
              <Box component="li">Tax or billing information where required</Box>
            </Box>
            Payment processors operate under their own privacy policies and
            terms.
          </Typography>

          {/* 1.9 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.9 Course Monetization and Creator Payment Information
          </Typography>
          <Typography>
            If you connect a payment account to monetize courses or other
            offerings, we may collect information necessary to support platform
            functionality, including:
            <Box component="ul">
              <Box component="li">Payment processor account identifiers</Box>
              <Box component="li">Connected account status</Box>
              <Box component="li">Course pricing information</Box>
              <Box component="li">Transaction metadata</Box>
              <Box component="li">Subscription or purchase activity</Box>
              <Box component="li">Payout status metadata where available</Box>
            </Box>
            OceSha does not store full banking credentials or full payment card
            numbers.
          </Typography>

          {/* 1.10 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1.10 Usage, Device, and Technical Data
          </Typography>
          <Typography>
            We automatically collect certain technical and usage information,
            including:
            <Box component="ul">
              <Box component="li">IP address</Box>
              <Box component="li">Device type</Box>
              <Box component="li">Browser type</Box>
              <Box component="li">Operating system</Box>
              <Box component="li">Referring URLs</Box>
              <Box component="li">Pages viewed</Box>
              <Box component="li">Features used</Box>
              <Box component="li">Log data</Box>
              <Box component="li">Error logs</Box>
              <Box component="li">Session activity</Box>
              <Box component="li">Performance data</Box>
              <Box component="li">Approximate location derived from IP address</Box>
              <Box component="li">Cookies and similar technologies</Box>
            </Box>
            This information helps us operate, secure, improve, and personalize
            the Services.
          </Typography>

          {/* Section 2 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2. How We Use Information
          </Typography>
          <Typography>
            We use collected information to:
            <Box component="ul">
              <Box component="li">Provide, operate, and maintain the Services</Box>
              <Box component="li">Create and manage user accounts</Box>
              <Box component="li">Process subscriptions and billing</Box>
              <Box component="li">Generate AI-assisted Outputs</Box>
              <Box component="li">Train and personalize your Digital Twin experience</Box>
              <Box component="li">Process uploaded content</Box>
              <Box component="li">Generate content recommendations</Box>
              <Box component="li">Create blogs, courses, clips, social posts, and related materials</Box>
              <Box component="li">Publish and manage Authority Pages</Box>
              <Box component="li">Enable AI Concierge interactions</Box>
              <Box component="li">Support voice personalization and synthetic voice functionality</Box>
              <Box component="li">Provide lead capture and messaging features</Box>
              <Box component="li">Enable social publishing and platform integrations</Box>
              <Box component="li">Improve system performance</Box>
              <Box component="li">Detect fraud, abuse, and security threats</Box>
              <Box component="li">Provide customer support</Box>
              <Box component="li">Communicate with you about account, billing, product, or security matters</Box>
              <Box component="li">Comply with legal obligations</Box>
              <Box component="li">Enforce our Terms of Service</Box>
              <Box component="li">Improve platform functionality using aggregated or anonymized information</Box>
            </Box>
            We do not sell your personal information or private uploaded User
            Content.
          </Typography>

          {/* Section 3 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            3. User Content Ownership and Processing
          </Typography>
          <Typography>
            You retain ownership of the content you upload, submit, paste,
            connect, record, or otherwise provide to the Services.
            <br />
            <br />
            By uploading or submitting User Content, you grant OceSha a limited,
            non-exclusive, worldwide license to host, store, process, reproduce,
            transform, analyze, display, and use the content solely as necessary
            to provide, maintain, secure, and improve the Services for your
            account.
            <br />
            <br />
            You represent and warrant that:
            <Box component="ul">
              <Box component="li">You own or have sufficient rights to upload and process the User Content</Box>
              <Box component="li">Your User Content does not violate intellectual property rights</Box>
              <Box component="li">Your User Content does not violate privacy, publicity, confidentiality, or contractual rights</Box>
              <Box component="li">Your User Content does not contain unlawful material</Box>
              <Box component="li">You have obtained all necessary permissions for any third-party content, voice, likeness, image, or data included in your uploads</Box>
            </Box>
            OceSha is not responsible for claims arising from User Content you
            upload or publish.
          </Typography>

          {/* Section 4 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            4. AI Processing and Generated Outputs
          </Typography>
          <Typography>
            OceSha uses artificial intelligence, machine learning, retrieval
            systems, generative AI systems, speech technologies, and other
            automated systems to process User Content and generate outputs.
            <br />
            <br />
            AI-generated outputs may include:
            <Box component="ul">
              <Box component="li">Blog drafts</Box>
              <Box component="li">Social posts</Box>
              <Box component="li">Course content</Box>
              <Box component="li">Clips and summaries</Box>
              <Box component="li">Images or visual content</Box>
              <Box component="li">Authority Page content</Box>
              <Box component="li">Digital Twin responses</Box>
              <Box component="li">AI Concierge responses</Box>
              <Box component="li">Educational materials</Box>
              <Box component="li">Content recommendations</Box>
              <Box component="li">Lead engagement responses</Box>
            </Box>
            You acknowledge that AI-generated outputs:
            <Box component="ul">
              <Box component="li">May be inaccurate, incomplete, misleading, outdated, offensive, or non-unique</Box>
              <Box component="li">May require human review</Box>
              <Box component="li">May not be suitable for every use case</Box>
              <Box component="li">May not constitute professional advice</Box>
              <Box component="li">May be similar to outputs generated for other users</Box>
            </Box>
            You are responsible for reviewing, approving, editing, publishing,
            or relying on any AI-generated output.
            <br />
            <br />
            Unless explicitly stated otherwise, private User Content is not used
            to train publicly available AI models.
            <br />
            <br />
            OceSha may use aggregated, anonymized, or de-identified usage data
            to improve platform performance, reliability, infrastructure, and
            user experience.
          </Typography>

          {/* Section 5 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            5. Digital Twin and Synthetic Voice Processing
          </Typography>
          <Typography>
            OceSha’s Digital Twin features may use your uploaded content,
            interview responses, account settings, profile information, and
            voice interactions to create AI-powered experiences that help
            represent your expertise, communication style, and knowledge.
            <br />
            <br />
            Your Digital Twin may be used to:
            <Box component="ul">
              <Box component="li">Generate content</Box>
              <Box component="li">Recommend content ideas</Box>
              <Box component="li">Support audience interactions</Box>
              <Box component="li">Answer questions</Box>
              <Box component="li">Teach or support courses</Box>
              <Box component="li">Power Authority Page experiences</Box>
              <Box component="li">Provide AI-powered educational or engagement experiences</Box>
            </Box>
            If you provide voice data, OceSha may use it to create or support
            synthetic voice experiences associated with your Digital Twin.
            <br />
            <br />
            You acknowledge and agree that:
            <Box component="ul">
              <Box component="li">Synthetic voice outputs are AI-generated</Box>
              <Box component="li">Your Digital Twin may sound similar to your voice or speaking style</Box>
              <Box component="li">Digital Twin outputs are not live human communications</Box>
              <Box component="li">AI-generated voice may not perfectly match your actual voice</Box>
              <Box component="li">You remain responsible for how your Digital Twin is used and represented</Box>
            </Box>
            You may request deletion or modification of Digital Twin data as
            described in this Privacy Policy, subject to legal, operational, and
            backup retention requirements.
          </Typography>

          {/* Section 6 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            6. Public Authority Pages, Publishing, and Search Indexing
          </Typography>
          <Typography>
            OceSha allows users to create public Authority Pages and publish
            public content, including blogs, courses, videos, clips, social
            content, and Digital Twin-powered experiences.
            <br />
            <br />
            If you publish content or make an Authority Page public, you
            understand and agree that:
            <Box component="ul">
              <Box component="li">The content may be publicly accessible</Box>
              <Box component="li">The content may be indexed by search engines</Box>
              <Box component="li">The content may be crawled, cached, summarized, or referenced by third-party systems</Box>
              <Box component="li">The content may appear in AI-powered search experiences or answer engines</Box>
              <Box component="li">Cached or indexed copies may persist after you edit, unpublish, delete, or cancel your account</Box>
              <Box component="li">OceSha cannot control third-party search engines, AI systems, web archives, or external crawlers</Box>
            </Box>
            If you cancel your subscription or close your account, OceSha may,
            according to its policies and operational needs:
            <Box component="ul">
              <Box component="li">Keep public content live for a limited period</Box>
              <Box component="li">Convert public content to a limited preview state</Box>
              <Box component="li">Archive public content</Box>
              <Box component="li">Disable editing or publishing features</Box>
              <Box component="li">Redirect public URLs</Box>
              <Box component="li">Remove public content</Box>
              <Box component="li">Retain certain records where legally required</Box>
            </Box>
            OceSha does not guarantee continued hosting of canceled or inactive
            account content unless expressly stated in a separate agreement.
          </Typography>

          {/* Section 7 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            7. Lead Capture, Messaging, and Audience Data
          </Typography>
          <Typography>
            OceSha may provide tools that allow visitors, students, subscribers,
            or audience members to contact you, follow you, subscribe, enroll in
            courses, or provide lead information.
            <br />
            <br />
            If you use these features, you are responsible for:
            <Box component="ul">
              <Box component="li">Using audience data lawfully</Box>
              <Box component="li">Obtaining any required consent</Box>
              <Box component="li">Complying with email, marketing, privacy, and communication laws</Box>
              <Box component="li">Honoring unsubscribe or deletion requests where applicable</Box>
              <Box component="li">Protecting exported lead or audience data</Box>
            </Box>
            OceSha may process lead and message information to provide the
            Services, deliver messages, display analytics, support exports, and
            maintain platform security.
            <br />
            <br />
            We do not sell your leads or audience data.
          </Typography>

          {/* Section 8 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            8. Social Publishing and Third-Party Integrations
          </Typography>
          <Typography>
            OceSha may allow you to connect third-party services such as
            LinkedIn, X, Facebook, YouTube, Stripe, analytics tools, or other
            platforms.
            <br />
            <br />
            When you connect third-party services:
            <Box component="ul">
              <Box component="li">We may collect and store access tokens, permissions, account identifiers, and publishing metadata as needed to provide the integration</Box>
              <Box component="li">Your use of third-party services is governed by their own terms and privacy policies</Box>
              <Box component="li">OceSha is not responsible for third-party platform practices</Box>
              <Box component="li">You may disconnect integrations where supported</Box>
            </Box>
            When you publish to third-party platforms, your content becomes
            subject to those platforms’ privacy policies, terms, moderation
            rules, and data practices.
          </Typography>

          {/* Section 9 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            9. Payment Processing and Billing
          </Typography>
          <Typography>
            OceSha uses third-party payment processors to handle subscriptions,
            invoices, billing, creator monetization, and related payments.
            <br />
            <br />
            We do not store full credit card numbers or full banking credentials.
            <br />
            <br />
            Payment processors may collect and process:
            <Box component="ul">
              <Box component="li">Payment card information</Box>
              <Box component="li">Bank account information</Box>
              <Box component="li">Billing details</Box>
              <Box component="li">Tax information</Box>
              <Box component="li">Identity verification information</Box>
              <Box component="li">Transaction history</Box>
            </Box>
            Such information is handled by the payment processor according to
            its own privacy policy and terms.
            <br />
            <br />
            OceSha may retain billing metadata, subscription status, invoice
            records, transaction identifiers, and related account information for
            accounting, customer support, compliance, fraud prevention, and
            operational purposes.
          </Typography>

          {/* Section 10 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            10. Data Sharing
          </Typography>
          <Typography>
            We may share limited information with trusted third parties only as
            necessary to provide, secure, and improve the Services.
            <br />
            <br />
            These may include:
            <Box component="ul">
              <Box component="li">Cloud hosting providers</Box>
              <Box component="li">Infrastructure providers</Box>
              <Box component="li">Payment processors</Box>
              <Box component="li">Analytics providers</Box>
              <Box component="li">Email and communication providers</Box>
              <Box component="li">Security monitoring providers</Box>
              <Box component="li">Customer support tools</Box>
              <Box component="li">Legal, compliance, or professional advisors</Box>
              <Box component="li">Government or law enforcement authorities where required by law</Box>
            </Box>
            We do not sell your personal information or private User Content.
            <br />
            <br />
            We may disclose information if we believe it is necessary to:
            <Box component="ul">
              <Box component="li">Comply with applicable law</Box>
              <Box component="li">Enforce our Terms of Service</Box>
              <Box component="li">Protect OceSha, users, or the public</Box>
              <Box component="li">Detect fraud, abuse, or security threats</Box>
              <Box component="li">Respond to lawful requests</Box>
            </Box>
          </Typography>

          {/* Section 11 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            11. Business Transfers
          </Typography>
          <Typography>
            If OceSha is involved in a merger, acquisition, financing,
            reorganization, sale of assets, bankruptcy, or similar business
            transaction, information may be transferred as part of that
            transaction.
            <br />
            <br />
            If such a transfer occurs, we will take reasonable steps to ensure
            that your information remains subject to privacy protections
            consistent with this Privacy Policy or provide notice where required
            by law.
          </Typography>

          {/* Section 12 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            12. Data Retention
          </Typography>
          <Typography>
            We retain information for as long as reasonably necessary to:
            <Box component="ul">
              <Box component="li">Provide the Services</Box>
              <Box component="li">Maintain your account</Box>
              <Box component="li">Support Digital Twin functionality</Box>
              <Box component="li">Maintain published content and Authority Pages</Box>
              <Box component="li">Process billing and accounting records</Box>
              <Box component="li">Resolve disputes</Box>
              <Box component="li">Enforce agreements</Box>
              <Box component="li">Prevent fraud and abuse</Box>
              <Box component="li">Comply with legal obligations</Box>
            </Box>
            Retention periods may vary based on data type, account status, legal
            requirements, and operational needs.
            <br />
            <br />
            If you cancel your subscription, we may retain your account data,
            uploaded content, generated content, public content, and related
            records for a reasonable period to allow reactivation, comply with
            legal requirements, prevent fraud, maintain platform integrity, or
            manage public URL behavior.
            <br />
            <br />
            If you delete your account, we will delete or anonymize personal
            data where required, subject to:
            <Box component="ul">
              <Box component="li">Legal retention obligations</Box>
              <Box component="li">Backup systems</Box>
              <Box component="li">Fraud prevention</Box>
              <Box component="li">Dispute resolution</Box>
              <Box component="li">Accounting records</Box>
              <Box component="li">Public content indexing outside our control</Box>
              <Box component="li">Previously published third-party content</Box>
            </Box>
          </Typography>

          {/* Section 13 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            13. Account Cancellation and Content Removal
          </Typography>
          <Typography>
            If you cancel your subscription:
            <Box component="ul">
              <Box component="li">Your access to premium features may end at the conclusion of your billing or trial period</Box>
              <Box component="li">You may lose access to publishing, editing, generation, monetization, or Digital Twin features depending on your plan status</Box>
              <Box component="li">Your public Authority Page and published content may remain live, be converted to a preview state, be archived, be redirected, or be removed according to OceSha’s policies</Box>
              <Box component="li">Your data may be retained for a reasonable period to support reactivation, legal compliance, and operational continuity</Box>
            </Box>
            If you request deletion of your account or content, we will process
            the request according to applicable law and platform policies.
            <br />
            <br />
            OceSha cannot guarantee removal of content from third-party
            platforms, search engines, caches, AI search systems, web archives,
            or external websites after content has been made public.
          </Typography>

          {/* Section 14 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            14. Cookies and Tracking Technologies
          </Typography>
          <Typography>
            We may use cookies, pixels, local storage, analytics tools, and
            similar technologies to:
            <Box component="ul">
              <Box component="li">Keep you logged in</Box>
              <Box component="li">Remember preferences</Box>
              <Box component="li">Analyze usage</Box>
              <Box component="li">Improve performance</Box>
              <Box component="li">Secure the platform</Box>
              <Box component="li">Understand traffic sources</Box>
              <Box component="li">Support product functionality</Box>
            </Box>
            You may control cookies through your browser settings. Some features
            may not function properly if cookies are disabled.
          </Typography>

          {/* Section 15 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            15. Data Security
          </Typography>
          <Typography>
            We use commercially reasonable administrative, technical, and
            organizational safeguards designed to protect personal information,
            User Content, voice data, and platform data.
            <br />
            <br />
            These safeguards may include:
            <Box component="ul">
              <Box component="li">Encryption in transit</Box>
              <Box component="li">Access controls</Box>
              <Box component="li">Secure cloud infrastructure</Box>
              <Box component="li">Authentication protections</Box>
              <Box component="li">Limited internal access</Box>
              <Box component="li">Monitoring and logging</Box>
              <Box component="li">Security review practices</Box>
            </Box>
            However, no system is completely secure. You acknowledge that
            internet-based services involve inherent risks, and OceSha cannot
            guarantee absolute security.
            <br />
            <br />
            You are responsible for maintaining the confidentiality of your
            account credentials and for activity under your account.
          </Typography>

          {/* Section 16 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            16. Your Privacy Rights
          </Typography>
          <Typography>
            Depending on your jurisdiction, you may have rights to:
            <Box component="ul">
              <Box component="li">Access personal information</Box>
              <Box component="li">Correct inaccurate information</Box>
              <Box component="li">Request deletion</Box>
              <Box component="li">Restrict processing</Box>
              <Box component="li">Object to processing</Box>
              <Box component="li">Request data portability</Box>
              <Box component="li">Withdraw consent where applicable</Box>
              <Box component="li">Opt out of certain data uses</Box>
            </Box>
            To exercise rights, contact:{" "}
            <Link
              to=""
              onClick={(e) => {
                window.location.href = `mailto:support@ocesha.com`;
                e.preventDefault();
              }}
              style={{
                color: "#0168B5",
              }}
            >
              support@ocesha.com
            </Link>
            <br />
            <br />
            We may verify your identity before fulfilling requests.
            <br />
            <br />
            Some requests may be limited by legal obligations, security
            requirements, operational requirements, or the rights of others.
          </Typography>

          {/* Section 17 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            17. California Privacy Rights
          </Typography>
          <Typography>
            If you are a California resident, you may have rights under
            California privacy laws, including the California Consumer Privacy
            Act and related laws.
            <br />
            <br />
            These rights may include:
            <Box component="ul">
              <Box component="li">The right to know what personal information we collect</Box>
              <Box component="li">The right to request deletion</Box>
              <Box component="li">The right to correct inaccurate information</Box>
              <Box component="li">The right to know whether personal information is sold or shared</Box>
              <Box component="li">The right to opt out of certain sharing where applicable</Box>
              <Box component="li">The right not to be discriminated against for exercising privacy rights</Box>
            </Box>
            OceSha does not sell personal information.
            <br />
            <br />
            To submit a California privacy request, contact:{" "}
            <Link
              to=""
              onClick={(e) => {
                window.location.href = `mailto:support@ocesha.com`;
                e.preventDefault();
              }}
              style={{
                color: "#0168B5",
              }}
            >
              support@ocesha.com
            </Link>
          </Typography>

          {/* Section 18 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            18. European Union / United Kingdom Privacy Rights
          </Typography>
          <Typography>
            If you are located in the European Union, European Economic Area, or
            United Kingdom, applicable privacy laws may provide additional
            rights.
            <br />
            <br />
            Legal bases for processing may include:
            <Box component="ul">
              <Box component="li">Performance of a contract</Box>
              <Box component="li">Consent</Box>
              <Box component="li">Legitimate interests</Box>
              <Box component="li">Legal obligations</Box>
              <Box component="li">Protection of rights and security</Box>
            </Box>
            Your data may be processed in the United States or other
            jurisdictions that may not provide the same level of data protection
            as your home jurisdiction.
            <br />
            <br />
            Where required, we take appropriate steps to protect international
            transfers.
            <br />
            <br />
            You may contact us to request access, correction, deletion,
            restriction, portability, or objection to processing.
          </Typography>

          {/* Section 19 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            19. Children's Privacy
          </Typography>
          <Typography>
            The Services are not intended for individuals under 18 years old.
            <br />
            <br />
            We do not knowingly collect personal information from minors under
            18.
            <br />
            <br />
            If you believe a minor has provided personal information, contact us
            at:{" "}
            <Link
              to=""
              onClick={(e) => {
                window.location.href = `mailto:support@ocesha.com`;
                e.preventDefault();
              }}
              style={{
                color: "#0168B5",
              }}
            >
              support@ocesha.com
            </Link>{" "}
            and we will take appropriate action.
          </Typography>

          {/* Section 20 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            20. Copyright and DMCA Notices
          </Typography>
          <Typography>
            If you believe content on OceSha infringes your copyright, you may
            submit a copyright notice to:{" "}
            <Link
              to=""
              onClick={(e) => {
                window.location.href = `mailto:support@ocesha.com`;
                e.preventDefault();
              }}
              style={{
                color: "#0168B5",
              }}
            >
              support@ocesha.com
            </Link>
            <br />
            <br />
            Your notice should include:
            <Box component="ul">
              <Box component="li">Identification of the copyrighted work</Box>
              <Box component="li">Identification of the allegedly infringing material</Box>
              <Box component="li">Your contact information</Box>
              <Box component="li">A statement that you have a good-faith belief the use is unauthorized</Box>
              <Box component="li">A statement that the information in the notice is accurate</Box>
              <Box component="li">Your physical or electronic signature</Box>
            </Box>
            OceSha may remove or disable access to content alleged to be
            infringing and may terminate repeat infringers where appropriate.
          </Typography>

          {/* Section 21 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            21. Automated Decision-Making and AI Systems
          </Typography>
          <Typography>
            OceSha uses automated systems to provide recommendations, generate
            content, analyze uploaded materials, personalize Digital Twin
            experiences, and improve platform performance.
            <br />
            <br />
            These systems may influence:
            <Box component="ul">
              <Box component="li">Content recommendations</Box>
              <Box component="li">Dashboard suggestions</Box>
              <Box component="li">AI-generated outputs</Box>
              <Box component="li">Course ideas</Box>
              <Box component="li">Authority Page content</Box>
              <Box component="li">Digital Twin responses</Box>
              <Box component="li">Publishing suggestions</Box>
            </Box>
            You remain responsible for reviewing and approving content before
            publishing or relying on it.
          </Typography>

          {/* Section 22 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            22. Email Communications
          </Typography>
          <Typography>
            We may send you emails related to:
            <Box component="ul">
              <Box component="li">Account creation</Box>
              <Box component="li">Onboarding</Box>
              <Box component="li">Product updates</Box>
              <Box component="li">Billing and subscription notices</Box>
              <Box component="li">Security alerts</Box>
              <Box component="li">Support messages</Box>
              <Box component="li">Platform usage</Box>
              <Box component="li">Marketing or educational content</Box>
            </Box>
            You may unsubscribe from marketing emails where available.
            Transactional or account-related emails may still be sent as
            necessary to provide the Services.
          </Typography>

          {/* Section 23 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            23. International Data Transfers
          </Typography>
          <Typography>
            Your information may be processed in the United States or other
            countries where OceSha or its service providers operate.
            <br />
            <br />
            By using the Services, you acknowledge that your information may be
            transferred to and processed in jurisdictions outside your country
            of residence.
          </Typography>

          {/* Section 24 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            24. Changes to This Privacy Policy
          </Typography>
          <Typography>
            We may update this Privacy Policy from time to time.
            <br />
            <br />
            If we make material changes, we may provide notice through:
            <Box component="ul">
              <Box component="li">The Services</Box>
              <Box component="li">Email</Box>
              <Box component="li">Website notice</Box>
              <Box component="li">Account notification</Box>
            </Box>
            Continued use of the Services after an updated Privacy Policy
            becomes effective constitutes acceptance of the updated policy.
          </Typography>

          {/* Section 25 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            25. Contact Us
          </Typography>
          <Typography>
            If you have questions about this Privacy Policy, your data, or your
            privacy rights, contact us at:
            <br />
            <br />
            OceSha, Inc.
            <br />
            <Link
              to=""
              onClick={(e) => {
                window.location.href = `mailto:support@ocesha.com`;
                e.preventDefault();
              }}
              style={{
                color: "#0168B5",
              }}
            >
              support@ocesha.com
            </Link>
            <br />
            <Link
              to=""
              onClick={(e) => {
                window.location.href = `https://ocesha.ai/`;
                e.preventDefault();
              }}
              style={{
                color: "#0168B5",
              }}
            >
              https://ocesha.ai
            </Link>
          </Typography>

          {/* Section 26 */}
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            26. Summary of Key Privacy Commitments
          </Typography>
          <Typography>
            For clarity, OceSha’s key privacy commitments are:
            <Box component="ul">
              <Box component="li">We do not sell your personal information.</Box>
              <Box component="li">We do not sell your private uploaded content.</Box>
              <Box component="li">You retain ownership of your uploaded content.</Box>
              <Box component="li">Your private uploaded content is not used to train public AI models unless expressly disclosed and separately consented to.</Box>
              <Box component="li">Voice data is used only for supported Digital Twin experiences associated with your account unless you provide separate consent.</Box>
              <Box component="li">Published public content may be indexed, cached, or referenced by third-party search engines and AI systems.</Box>
              <Box component="li">You remain responsible for reviewing AI-generated outputs before publishing or relying on them.</Box>
              <Box component="li">You may contact us to request access, correction, deletion, or other privacy rights where applicable.</Box>
            </Box>
          </Typography>

          <Link
            to="/signin"
            style={{
              display: "flex",
              marginTop: 40,
              textDecoration: "none",
              color: "white",
            }}
          >
            <SvgIcon sx={{ mr: 1 }}>
              <KeyboardBackspace />
            </SvgIcon>
            Back to log in
          </Link>
        </Box>
      </Container>
    </>
  );
};

export default PrivacyPage;